import {
  CaptureConsole as CaptureConsoleIntegration,
  ExtraErrorData as ExtraErrorDataIntegration,
  Offline as OfflineIntegration,
} from '@sentry/integrations';
import * as SentryReact from '@sentry/react';
import {PagewebEnv} from '../common/env/PagewebEnv.interface';
import {requestContext} from '../common/requestContext';

export function initSentryClient(env: PagewebEnv) {
  if (initialized) {
    return;
  }
  initialized = true;

  SentryReact.init({
    dsn: env.sentryDsn,
    release: env.version,
    environment: `${env.envName}-client`,
    tracesSampleRate: env.envName === 'real' ? 0.25 : 1,
    integrations: [
      new ExtraErrorDataIntegration(),
      new CaptureConsoleIntegration({levels: ['error']}),
      new OfflineIntegration(),
    ],
    ignoreErrors: [
      // request 캔슬시 발생하는 에러를 무시합니다 https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
      'TypeError: Cancelled',
    ],
    beforeSend: event => {
      if (event && event.message?.match(/Warning/i)) {
        event.level = 'warning';
      }
      return event;
    },
  });
  SentryReact.setTags({
    deviceId: requestContext.requestInfo.deviceId,
    requestId: requestContext.requestInfo.requestId,
    appUserId: requestContext.requestInfo.user?.appUserId,
    userId: requestContext.requestInfo.user?.uid,
  });
}

let initialized = false;
